import React from 'react';

import { Wrapper } from './styles';

export function FooterInfoBar() {
  return (
    <Wrapper>
      <div className="infobar-wrapper">
        <p>
          <b>Your privacy is important to us.</b> Like most websites and online
          services, Prodigy collects cookies to provide the most fulfilling
          experience when you visit our website. For more information, please
          visit our{' '}
          <a
            href="https://www.prodigygame.com/main-en/terms-and-conditions/"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Use
          </a>{' '}
          and our{' '}
          <a
            href="https://www.prodigygame.com/main-en/privacy-policy/"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>{' '}
          .
        </p>
      </div>
    </Wrapper>
  );
}
